import { Text } from '@wix/design-system';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import styles from '../RevShare.scss';
export const RevShareCycleSubtitle = _ref => {
  let {
    formattedAmount
  } = _ref;
  const module = useCurrentModule();
  const {
    Trans
  } = module.internals.useTranslations();
  React.useEffect(() => {
    module.internals.bi.onRevshareSubtitleLoad == null || module.internals.bi.onRevshareSubtitleLoad({});
  }, []);
  return /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "studio_package_picker.header.billing_cycle.revshare.subtitle",
    components: {
      strong: /*#__PURE__*/React.createElement(Text, {
        weight: "bold",
        className: styles.revShareAmount
      })
    },
    values: {
      amountEarned: formattedAmount
    }
  }));
};
//# sourceMappingURL=RevShareCycleSubtitle.js.map